import { render, staticRenderFns } from "./ProjectMaterial.vue?vue&type=template&id=537984bf"
import script from "./ProjectMaterial.vue?vue&type=script&lang=js"
export * from "./ProjectMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports